import { Button } from "@/components/bnp-ui";
import Image from "next/image";
import React from "react";

const NewUser = ({ setNewUser }: any) => {
  return (
    <div className="flex flex-col lg:flex-row w-full max-w-[600px] mx-auto">
      <div className="flex flex-col lg:flex-row w-full">
        <div className="hidden lg:block relative flex-shrink-0">
          <div className="absolute top-[12%] left-[12%] text-center z-20 text-main-900 text-sm lg:text-base">
            Can&apos;t Be There for a<br /> Property Inspection?
            <br />
            <span className="font-playfair text-bnp-cyan font-bold italic text-sm lg:text-base">
              {" "}
              We&apos;ve Got You Covered!
            </span>
          </div>
          <Image
            src={"/assets/images/liveInspection.png"}
            width={300}
            height={300}
            alt="live-inspection"
          />
        </div>

        <div className="w-full lg:w-[55%] px-4">
          <h2 className="font-medium text-sm sm:text-base mt-4 text-main-900 w-full mb-4">
            You can have a trusted expert inspect any property
          </h2>

          <p className="text-main-900 text-sm w-full">
            Are you interested in purchasing or renting a property but
            can&apos;t be there in person to inspect it? Whether you&apos;re
            overseas or have a busy schedule, our Live Inspection Request
            service ensures that you don&apos;t miss out on the critical details
            of your property search.
          </p>

          <p className="text-main-900 text-sm w-full mt-4">
            Our expert team will visit the property on your behalf, conduct a
            thorough inspection, and provide you with a detailed, comprehensive
            report. Through high-quality photos, videos, and other report
            materials, you&apos;ll get a first-hand look at the property — just
            as if you were there yourself.
          </p>
          <Button
            type="submit"
            className="bg-bnp-cyan mt-8 text-white text-sm font-semibold w-full h-[60px] rounded-lg"
            onClick={() => setNewUser(false)}
          >
            I understand, let&apos;s go
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NewUser;
